var _path, _rect, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoreInfoDefaultState = function SvgMoreInfoDefaultState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 23.9091C19.5249 23.9091 24.4091 19.0249 24.4091 13C24.4091 6.97508 19.5249 2.09091 13.5 2.09091C7.47508 2.09091 2.59091 6.97508 2.59091 13C2.59091 19.0249 7.47508 23.9091 13.5 23.9091ZM13.5 25C20.1274 25 25.5 19.6274 25.5 13C25.5 6.37258 20.1274 1 13.5 1C6.87258 1 1.5 6.37258 1.5 13C1.5 19.6274 6.87258 25 13.5 25Z",
    fill: "#F1F1F1",
    stroke: "#F1F1F1",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 10,
    width: 3,
    height: 10,
    rx: 1.5,
    fill: "#F1F1F1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 7.5,
    r: 1.5,
    fill: "#F1F1F1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoreInfoDefaultState);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy41IDIzLjkwOTFDMTkuNTI0OSAyMy45MDkxIDI0LjQwOTEgMTkuMDI0OSAyNC40MDkxIDEzQzI0LjQwOTEgNi45NzUwOCAxOS41MjQ5IDIuMDkwOTEgMTMuNSAyLjA5MDkxQzcuNDc1MDggMi4wOTA5MSAyLjU5MDkxIDYuOTc1MDggMi41OTA5MSAxM0MyLjU5MDkxIDE5LjAyNDkgNy40NzUwOCAyMy45MDkxIDEzLjUgMjMuOTA5MVpNMTMuNSAyNUMyMC4xMjc0IDI1IDI1LjUgMTkuNjI3NCAyNS41IDEzQzI1LjUgNi4zNzI1OCAyMC4xMjc0IDEgMTMuNSAxQzYuODcyNTggMSAxLjUgNi4zNzI1OCAxLjUgMTNDMS41IDE5LjYyNzQgNi44NzI1OCAyNSAxMy41IDI1WiIgZmlsbD0iI0YxRjFGMSIgc3Ryb2tlPSIjRjFGMUYxIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cmVjdCB4PSIxMi41IiB5PSIxMCIgd2lkdGg9IjMiIGhlaWdodD0iMTAiIHJ4PSIxLjUiIGZpbGw9IiNGMUYxRjEiLz4KPGNpcmNsZSBjeD0iMTQiIGN5PSI3LjUiIHI9IjEuNSIgZmlsbD0iI0YxRjFGMSIvPgo8L3N2Zz4K";